import api from "./api";

// Admin view of incentives. Team members use the call/chat team endpoints instead,
// which only ever return the caller's own figures.
export const getIncentiveOverview = async (period) => {
  const { data } = await api.get("/api/admin/incentives", { params: { period: period || undefined } });
  return data;
};

export const getMemberIncentiveMonth = async (memberId, period) => {
  const { data } = await api.get(`/api/admin/incentives/members/${memberId}`, {
    params: { period: period || undefined },
  });
  return data;
};

export const listIncentiveSlabSets = async () => {
  const { data } = await api.get("/api/admin/incentives/slabs");
  return Array.isArray(data) ? data : [];
};

export const saveIncentiveSlabSet = async (slabSet) => {
  if (slabSet.id) {
    const { data } = await api.put(`/api/admin/incentives/slabs/${slabSet.id}`, slabSet);
    return data;
  }
  const { data } = await api.post("/api/admin/incentives/slabs", slabSet);
  return data;
};

export const deleteIncentiveSlabSet = async (id) => {
  const { data } = await api.delete(`/api/admin/incentives/slabs/${id}`);
  return data;
};
